/**
 * El referido en tránsito: del enlace `/r/CODE` a la pantalla de
 * registro. `sessionStorage` a propósito — el patrocinio pertenece a
 * ESTA visita (quien abre el enlace de Ana hoy y vuelve solo la semana
 * que viene, vuelve sin patrocinador implícito), y no se filtra entre
 * pestañas.
 */

const KEY = "nh_referral";

export interface StoredReferral {
  /** El código canónico, ya validado y resuelto por el servidor. */
  code: string;
  /** "Ana Q." — lo que el resolvedor público responde para reconocerla. */
  displayName: string;
}

export function readReferral(): StoredReferral | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredReferral;
    return parsed && typeof parsed.code === "string" && typeof parsed.displayName === "string"
      ? parsed
      : null;
  } catch {
    return null;
  }
}

export function storeReferral(referral: StoredReferral): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(referral));
  } catch {
    // Sin almacenamiento (modo privado extremo): el registro sigue
    // funcionando, solo que sin arrastrar el código.
  }
}

export function clearReferral(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nada que limpiar.
  }
}
